/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export enum ApiWavesOverviewType {
    Latest = 'LATEST',
    MostSubscribed = 'MOST_SUBSCRIBED',
    HighLevelAuthor = 'HIGH_LEVEL_AUTHOR',
    AuthorYouHaveRepped = 'AUTHOR_YOU_HAVE_REPPED',
    MostDropped = 'MOST_DROPPED',
    MostDroppedByYou = 'MOST_DROPPED_BY_YOU',
    RecentlyDroppedTo = 'RECENTLY_DROPPED_TO',
    RecentlyDroppedToByYou = 'RECENTLY_DROPPED_TO_BY_YOU'
}
